// eslint-disable-next-line max-classes-per-file
import { Uuid } from '@ftr/contracts/type/shared'

export class CaseDeletedEvent {
  static readonly type = '[Cases] Case Deleted'

  constructor(readonly caseId: Uuid) {}
}

export class CaseDeletionFailedEvent {
  static readonly type = '[Cases] Case Deletion Failed'

  constructor(readonly caseId: Uuid) {}
}
